<template>
  <img src="@/assets/images/logos/company-logo-gak.webp"/>
</template>
<script setup>
</script>